import { z } from "zod";

import { versionSchema } from "./version-schema";

export const iotEdgeDeviceSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	edgeDeviceId: z.string(),
	alias: z.string(),
	version: versionSchema,
	iotHubName: z.string(),
	createdAt: z.string(),
	isDeleted: z.boolean(),
	deletedAt: z.string().nullable(),
});

export type IotEdgeDevice = z.infer<typeof iotEdgeDeviceSchema>;
